export const columnTranslations: Record<string, string> = {
  id: "ID",
  ncm: "NCM",
  state: "UF",
  iva: "IVA",
  internal_tax_rate: "Interno",
  interstate_tax: "Interestadual",
  is_active: "Status",
  created_at: "Criado Em",
  updated_at: "Atualizado Em",
  actions: "Ações",
  toggle: "Alterar Status",
};
